export default __webpack_public_path__ + "static/media/FINancials_Junior_GM_LVL_02.6d3cbdd8.mp4";